export default {
    values: {
        'Errors were found that can affect the rendering of the chart':
            'Foram encontrados erros que podem afetar a renderização do gráfico',
        'View the chart anyway': 'Visualizar o gráfico mesmo assim',
        Grid: 'Grade',
        'GLOBAL CHART OPTIONS': 'OPÇÕES GLOBAIS DO GRÁFICO',
        'Y AXIS OPTIONS': 'OPÇÕES DO EIXO Y',
        Groups: 'Grupos',
        'New Group': 'Novo Grupo',
        'Add Group': 'Adicionar Grupo',
        Remove: 'Remover',
        'Add groups and select channels to create a custom visualization':
            'Adicione grupos e selecione canais para criar visualizações customizadas',
        'Values grouped by grid.': 'Valores agrupados em grade.',
        'Number of columns': 'Número de colunas',
        'Title font size': 'Tamanho da fonte do título',
        'Value font size': 'Tamanho da fonte do valor',
        'Uom font size': 'Tamanho da fonte do uom',
        'Title bold': 'Título em negrito',
        'Value bold': 'Valor em negrito',
        'Uom bold': 'Uom em negrito',
        'Icon name': 'Nome do ícone',
        'Icon color': 'Cor do ícone',
        'Background color': 'Cor de fundo',
        ICON_NAME_DESCRIPTION: 'Nome do ícone do Font Awesome',
        'Group title': 'Título do grupo',
        'Custom alarm styles': 'Estilos customizados do alarme',
        Critical: 'Crítico',
        Warning: 'Alerta',
        Configured: 'Configurado',
        'Not mapped': 'Não mapeado',
        'Group color': 'Cor do grupo'
    }
}
